import ToolsPageItem from './ToolsPageItem';
import { HeaderPage } from '../components';
import SemaphoreLogo from '/semaphore.png';
import OpenPanelLogo from '/openpanel.png';
import MetabaseLogo from '/metabase.png';
import CoolifyLogo from '/coolify.png';
import BeszelLogo from '/beszel.png';
import SentryLogo from '/sentry.png';
import ShlinkLogo from '/shlink.png';
import UptimeLogo from '/uptime.png';
import PlunkLogo from '/plunk.png';
import routes from '@/lib/routes';
import NtfyLogo from '/ntfy.png';
import { cn } from '@/lib/utils';

const ToolsPage_ = () => {

  return (
    <div className='flex flex-col space-y-4 md:space-y-8 animate__animated animate__fadeIn'>
      <HeaderPage
        title='Outils'
        description={`Voici tous les outils utilisés pour le fonctionnement de Heyama.`} />
      <div className={cn(
        'grid gap-2',
        'grid-cols-2',
        'md:grid-cols-2',
        'lg:grid-cols-3',
        'xl:grid-cols-4',
      )}>
        <ToolsPageItem
          link={routes.links.analytics}
          title={'OpenPanel'}
          imageUrl={OpenPanelLogo}
          description={'Analytics'} />
        <ToolsPageItem
          link={routes.links.uptimeKuma}
          title={'Uptime Kuma'}
          imageUrl={UptimeLogo}
          description={'API Monitoring'} />
        <ToolsPageItem
          link={routes.links.beszel}
          title={'Beszel'}
          imageUrl={BeszelLogo}
          description={'Server Monitoring'} />
        <ToolsPageItem
          link={routes.links.semaphore}
          title={'Ansible Semaphore'}
          imageUrl={SemaphoreLogo}
          description={'Server deployment'} />
        <ToolsPageItem
          link={routes.links.sentry}
          title={'Sentry'}
          imageUrl={SentryLogo}
          description={'Error Reporting'} />
        <ToolsPageItem
          link={routes.links.plunk}
          title={'Plunk'}
          imageUrl={PlunkLogo}
          description={'Email Automation'} />
        <ToolsPageItem
          link={routes.links.shlink}
          title={'Shlink'}
          imageUrl={ShlinkLogo}
          description={'Links manager'} />
        <ToolsPageItem
          link={routes.links.ntfy}
          title={'Ntfy'}
          imageUrl={NtfyLogo}
          description={'Push notifications'} />
        <ToolsPageItem
          link={routes.links.metabase}
          title={'Metabase'}
          imageUrl={MetabaseLogo}
          description={'Data Analytics'} />
        <ToolsPageItem
          link={routes.links.coolify}
          title={'Coolify'}
          imageUrl={CoolifyLogo}
          description={'Self-hosting'} />
      </div>
    </div>
  );

};

export default ToolsPage_;
